import { IconName, type Quote, useCallbackRef } from '@talos/kyoko';
import { showRFQ } from '../../../../components/OMS/NewRFQ/RFQSlice';
import { openView } from '../../../../components/OMS/OMSSlice';
import { OMSView } from '../../../../components/OMS/OMSView';
import { useUser } from '../../../../hooks';
import { useAppStateDispatch } from '../../../../providers/AppStateProvider';

export const useShowRFQMenuItem = () => {
  const dispatch = useAppStateDispatch();
  const user = useUser();
  const handleShowRFQ = useCallbackRef((data: Quote) => {
    if (data.isProbablySalesRFQ) {
      // TODO: Implement this for sales RFQs
      return;
    }
    dispatch(openView(OMSView.RFQForm));
    dispatch(showRFQ(data));
  });

  return useCallbackRef((quote: Quote) => ({
    name: 'Show RFQ',
    action: () => handleShowRFQ(quote),
    /** TODO: Allow re-opening sales RFQs too */
    icon: `<i class="ag-icon ${IconName.Deepdive}"/>`,
    disabled: !quote.canOpenQuote || quote.User !== user.Name,
  }));
};
